import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { FamiliaService } from 'src/app/services/familia.service';
import { RubroService } from 'src/app/services/rubro.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-familia-modal-add-edit',
  templateUrl: './modal-add-edit.component.html',
  styleUrls: ['./modal-add-edit.component.scss'],
  providers: [SecurityService],
})
export class FamiliaModalAddEditComponent implements OnInit {

  // Modales
  @ViewChild('agregarFamilia', { static: true }) modalAddEditFamilia: ModalDirective;

  @Output() onAddEdit: EventEmitter<any> = new EventEmitter()

  // Form
  formData: FormGroup

  // Data &  Tmp
  optionsRubros: Array<any> = [];
  isEditing: boolean = false
  codigoEditado = 0
  private rutEmpresa: number

  // Utils

  constructor(
    private clog: ConsoleService,
    private familiaService: FamiliaService,
    private rubroService: RubroService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private messageRendererService: MessageRendererService,
    private toastrService: ToastService,
    private accesolocalstorage: SecurityService,
  ) { }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.createForm()
    this.loadRubros()
  }

  loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta
      this.optionsRubros = registros.map(rubro => ({
        value: rubro.codigo,
        label: rubro.descripcion
      }))
    })
  }

  private createForm() {
    this.formData = this.fb.group({
      activo: [true, [Validators.required]],
      nombre: [null, [Validators.required, Validators.maxLength(100), Validators.minLength(5)]],
      rubro: [null, [Validators.required]]
    });
  }

  show() {
    this.isEditing = false
    this.clearData()
    this.modalAddEditFamilia.show()
  }

  hide() {
    this.modalAddEditFamilia.hide()
  }

  load(familia) {
    this.isEditing = true
    this.codigoEditado = familia.codigo
    this.clearData()
    this.formData.get('activo').setValue(familia.activo)
    this.formData.get('nombre').setValue(familia.nombre)
    this.formData.get('rubro').setValue(familia.rubro_codigo)
    this.modalAddEditFamilia.show()
  }

  clearData() {
    this.formValidatorsService.reset(this.formData)
    this.formData.get('activo').setValue(true)
  }

  addEdit() {
    this.formValidatorsService.validateAllFormFields(this.formData)
    if (!this.formData.valid)
      return

    const inputParams: any = {
      entidad: {
        activo: this.formData.get('activo').value,
        nombre: this.formData.get('nombre').value,
        empresa_rut: this.rutEmpresa,
        rubro_codigo: Number(this.formData.get('rubro').value),
      }
    }
    if (this.isEditing)
      inputParams.entidad.codigo = this.codigoEditado

    this.familiaService.guardar(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastrService.success('Operación realizada con éxito')
      this.onAddEdit.emit(respuesta)
      this.hide()
    })
  }

}

